<div *ngIf="isLoggedIn" class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
  <div class="sidebar-header">
    <a href="#" class="sidebar-logo">
      <!-- <img class="" *ngIf="!isSidebarCollapsed" width="125px" height="48px" src='assets/eliwell_se.svg' /> -->
      <!-- <img class="" *ngIf="!isSidebarCollapsed" width="100px" height="48px" src='assets/eliwell_new_logo.png' /> -->
      <img class="" *ngIf="!isSidebarCollapsed" width="100px" height="48px" src='assets/eliwell_logo_new_white.svg' />
    </a>

    <qds-button class="sidebar-toggle-btn" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
      (click)="sidebarToggle.emit()" size="large" importance="subdued" icon-only="true" icon-name='chevron-right-edge'
      iconLibrary="default">
    </qds-button>

  </div>
  <div class="sidebar-menu">
    <div data-collapsed="false" data-divider="false" data-kicker="false" data-last="false" data-size="large"
      class="qds-nav-subsection">

      <div class="sidenav-list">
       

        <qds-nav-list-item icon-name="breaker" importance="standard" [text]="labels.myDevices | translate" subtitle="false" focus="false"
          class="menu" size="large" [routerLink]="['/dashboard']" [ngClass]="{ 'selectedMenu': isMyDeviceActive() }">>
          My Device 
        </qds-nav-list-item>
        <qds-nav-list-item *ngIf="roleCd === roles.enduser || roleCd === roles.installer || roleCd !== roles.MASTER"
          icon-name="bell-waves" importance="standard" [text]="labels.alarm | translate" subtitle="false" focus="false" class="menu"
          size="large" [routerLink]="['/alarm-management']" routerLinkActive="selectedMenu">
          Alarm
        </qds-nav-list-item>
        <qds-nav-list-item *ngIf="roleCd === roles.enduser || roleCd === roles.installer || roleCd !== roles.MASTER"
          icon-name="gear-writing-board" importance="standard" [text]="labels.menuHACCPReport | translate" subtitle="false" focus="false" class="menu"
          size="large" [routerLink]="['/haccpreports']" routerLinkActive="selectedMenu">
          HACCP Report
        </qds-nav-list-item>
        
        <qds-nav-list-item icon-name="gear" importance="standard" [text]="labels.system | translate" subtitle="false" focus="false"
          class="menu" size="large" [routerLink]="['/system']" routerLinkActive="selectedMenu">

        </qds-nav-list-item>
      </div>

    </div>
  </div>

</div>